<template>
  <div v-if="item">
    <button @click="downloadPdf" class="btn btn-info mb-4">Скачать PDF</button>
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "works",
    cardSetLink: "works",
    item: null,
    fields: [
      {
        col: "col-12 col-md-8",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-4",
        key: "given_seconds",
        label: "Сколько секунд на решение",
        type: "mask",
        mask: "###",
        textType: "number",
      },
      // {
      //   col: "col-12 col-md-12",
      //   key: "audio_document",
      //   label: "Аудио документ",
      //   type: "audio",
      // },
      {
        col: "col-12 col-md-12",
        key: "description",
        label: "Краткое описание задания",
        type: "textarea",
        textType: "text",
      },
      {
        col:'col-12 col-md-12',
        key: "autocheck",
        label: "Автопроверка",
        type: "checkbox",
      },
      // {
      //   col: "col-6 col-md-6",
      //   key: "complexity",
      //   label: "1 вопрос",
      //   type: "grade-price",
      //   textType: "number",
      // },
      // {
      //       col:'col-12 col-md-12',
      //       key: "is_time_limit",
      //       label: "Есть лимит времени",
      //       type: "checkbox",
      //  },
      //   {
      //       col:'col-12 col-md-12',
      //       key: "given_seconds",
      //       label: "Сколько секунд на решение",
      //               type: "mask",
      //       mask:'###',
      //       textType: "number",
      // },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    downloadPdf() {
      this.$loading(true);
      this.$http
        .get(`business/pdf/works/${this.item.id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.item.title;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error)
        .finally(() => {
          this.$loading(false);
        });
    },
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
